import { createClient } from '@supabase/supabase-js';

// 🔧 SETUP: Replace these two lines with your actual values from Supabase
// Go to: supabase.com → Your Project → Settings → API
const SUPABASE_URL = 'https://jtfvhiwnvfflzjzksuno.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_3qSk4LIhThbSx1NUXMYtxA_WLmmMUop';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
